import React from 'react';
import clsx from 'clsx';
import {makeStyles} from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import {PtrnState, PtrnTipoAccion} from '../../patronTypes';
import CampoEditable from '../CampoEditable';
import PtrnAccionButton from '../PtrnAccionButton';
import {css} from '../../../../constants';
import {PtrnEstilosGenerales, PtrnPropsUtil, PtrnStateUtil} from '../../patronUtils';
import {PtrnFormBaseProps} from './PtrnFormBaseTypes';
import PtrnTitulo from '../PtrnTitulo';
import {PtrnAccionesProps, PtrnEstadoSimpleProps, PtrnMainContentProps} from '../../patronProps';

const useStyles = makeStyles<number>()((theme, maxHeightVhMain) => {
   return {
      containerMainContent: PtrnEstilosGenerales.containerMainContent(maxHeightVhMain)
   };
});

function PtrnFormBase({
   //interfaz
   camposConfig,
   esActualizar,
   titulo,
   ignorarPrefijoTitulo,
   ptrnRef,
   accionInsert,
   accionUpdate,
   accionDelete,
   accionCancel,
   deshabilitarInsert,
   deshabilitarUpdate,
   deshabilitarDelete,
   maxHeightVhMain,
   localizacion,
   permitirEditarIdOnUpdate,
   //estado
   state,
   onChangeState,
   onBlurComponente,
   setState,
   //TODO implementar otras acciones
   accionesAdicionales
}: PtrnFormBaseProps & PtrnEstadoSimpleProps & PtrnAccionesProps & PtrnMainContentProps) {
   const {classes} = useStyles(maxHeightVhMain);
   if (ptrnRef && !ptrnRef.setForm) {
      ptrnRef.setForm = setState;
   }

   const {disabledInsert, disabledUpdate, disabledDelete} = PtrnPropsUtil.getDisabledAcciones(
      {deshabilitarInsert, deshabilitarUpdate, deshabilitarDelete},
      state as PtrnState
   );

   let tituloPrefix = localizacion?.form?.prefixNew || 'Nuevo';
   if (esActualizar) {
      tituloPrefix = localizacion?.form?.prefixEdit || 'Editar';
   }
   let tituloFinal = ignorarPrefijoTitulo ? titulo : `${tituloPrefix} ${titulo}`;

   if (localizacion?.form?.tituloEditar && esActualizar) {
      tituloFinal = localizacion.form.tituloEditar;
   }

   if (localizacion?.form?.tituloNuevo && !esActualizar) {
      tituloFinal = localizacion.form.tituloNuevo;
   }

   const idCompPrefix = 'ptrn-form-base';
   return (
      <Grid
         id={`${idCompPrefix}-grid-root`}
         container
         direction="column"
         justifyContent="space-between"
         spacing={2}
      >
         <Grid
            id={`${idCompPrefix}-grid-header`}
            container
            alignItems="center"
            spacing={1}
            item
            xs={12}
         >
            <PtrnTitulo>{tituloFinal}</PtrnTitulo>
         </Grid>
         <Grid item xs={12}>
            <Divider />
         </Grid>
         <Grid
            id={`${idCompPrefix}-grid-body-id`}
            className={clsx({
               [css.DS_CONTAINERDISABLED]: !permitirEditarIdOnUpdate && esActualizar
            })}
            container
            alignItems="center"
            spacing={1}
            item
            xs={12}
         >
            {camposConfig.map((curr, inx) => {
               if (!Boolean(curr.esId)) {
                  return null;
               }
               const {valor, errores} = PtrnStateUtil.getValor_Y_Error(state, curr);
               return (
                  <CampoEditable
                     key={curr.name}
                     campoConfig={curr}
                     camposData={state}
                     value={valor}
                     errores={errores}
                     onChange={onChangeState}
                     onBlur={onBlurComponente}
                     ptrnRef={ptrnRef}
                  />
               );
            })}
         </Grid>
         <Grid
            id={`${idCompPrefix}-grid-body-flds`}
            className={classes.containerMainContent}
            container
            item
            xs={12}
            spacing={1}
            alignItems="flex-start"
         >
            {camposConfig.map((curr, inx) => {
               if (Boolean(curr.esId)) {
                  return null;
               }
               const {valor, errores} = PtrnStateUtil.getValor_Y_Error(state, curr);
               return (
                  <CampoEditable
                     key={curr.name}
                     campoConfig={curr}
                     camposData={state}
                     value={valor}
                     errores={errores}
                     onChange={onChangeState}
                     onBlur={onBlurComponente}
                     ptrnRef={ptrnRef}
                  />
               );
            })}
         </Grid>
         <Grid
            id={`${idCompPrefix}-grid-footer`}
            container
            alignItems="center"
            justifyContent="space-between"
            spacing={1}
            item
            xs={12}
         >
            {accionDelete && esActualizar && (
               <Grid item xs={3}>
                  <PtrnAccionButton
                     name={`${idCompPrefix}-btn-delte`}
                     accion={{...accionDelete, tipo: PtrnTipoAccion.negativa}}
                     camposData={state}
                     ptrnRef={ptrnRef}
                     fullWidth
                     disabled={disabledDelete}
                  />
               </Grid>
            )}
            {accionCancel && (
               <Grid item xs={3}>
                  <PtrnAccionButton
                     name={`${idCompPrefix}-btn-cancel`}
                     accion={{...accionCancel, tipo: PtrnTipoAccion.neutra}}
                     camposData={state}
                     ptrnRef={ptrnRef}
                     fullWidth
                  />
               </Grid>
            )}
            {accionInsert && !esActualizar && (
               <Grid item xs={3}>
                  <PtrnAccionButton
                     name={`${idCompPrefix}-btn-insert`}
                     accion={{...accionInsert, tipo: PtrnTipoAccion.positiva}}
                     camposData={state}
                     ptrnRef={ptrnRef}
                     fullWidth
                     disabled={disabledInsert}
                  />
               </Grid>
            )}
            {accionUpdate && esActualizar && (
               <Grid item xs={3}>
                  <PtrnAccionButton
                     name={`${idCompPrefix}-btn-update`}
                     accion={{...accionUpdate, tipo: PtrnTipoAccion.positiva}}
                     camposData={state}
                     ptrnRef={ptrnRef}
                     fullWidth
                     disabled={disabledUpdate}
                  />
               </Grid>
            )}
         </Grid>
      </Grid>
   );
}

export default PtrnFormBase;
